import { styled } from "../../../styles/theme";

import { Flex } from "../ResponsiveBox";

interface ContainerProps {
  errors: string[];
  small: boolean;
  smallDropdown: boolean;
}

export const Container = styled(Flex)<ContainerProps>`
  position: relative;
  width: 100%;

  label {
    display: block;
    font-size: 14px;
    color: ${(p) => p.theme.colors.primary["500"]};
    font-weight: 600;
    margin-bottom: ${(p) => p.theme.spacing.xs};
  }

  .react-dropdown-select {
    background: ${(p) => p.theme.colors.white["100"]};
    min-height: initial;
    padding: 0;
    border: 1px solid
      ${(p) => p.theme.colors[p.errors.length > 0 ? "red" : "neutral"]["400"]};
    border-radius: ${(p) => p.theme.radius};
    box-shadow: none;

    &:hover {
      border-color: ${(p) => p.theme.colors.neutral["400"]};
    }

    // With validations

    &:focus,
    &:focus-within {
      border-color: ${(p) => p.theme.colors.blue["400"]};
      box-shadow: none;
    }

    .react-dropdown-select-content {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      width: calc(100% - 32px);
      padding: ${(p) =>
        p.small
          ? `${p.theme.spacing.xs} ${p.theme.spacing.sm}`
          : `${p.theme.spacing.sm} ${p.theme.spacing.md}`};

      .react-dropdown-select-input,
      span {
        font-family: ${(p) => p.theme.fonts.main};
        font-size: 14px;
        color: ${(p) => p.theme.colors.primary["500"]};
        margin-left: 0;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .react-dropdown-select-dropdown-handle {
      // icon chevron-down
      svg {
        display: block;
      }

      &:focus,
      &:hover {
        path {
          stroke: none;
        }
      }
    }

    .react-dropdown-select-dropdown {
      background: ${(p) => p.theme.colors.white[100]};
      width: 100%;
      padding: 14px 0;
      border: 1px solid ${(p) => p.theme.colors.neutral["400"]};
      border-radius: ${(p) => p.theme.radius};
      box-shadow: ${(p) => p.theme.shadow.xs};
      overflow: initial;

      .react-dropdown-select-item {
        background: transparent;
        font-size: ${(p) => (p.smallDropdown ? "12px" : "14px")};
        color: ${(p) => p.theme.colors.primary[500]};
        padding: ${(p) =>
          p.smallDropdown
            ? `6px ${p.theme.spacing.sm}`
            : `${p.theme.spacing.sm} ${p.theme.spacing.md}`};
        border: none;

        &:hover {
          background: ${(p) => p.theme.colors.neutral[200]};
        }
      }

      .react-dropdown-select-item-active {
        background: ${(p) => p.theme.colors.neutral[200]};
      }
    }
  }
`;
